export default __webpack_public_path__ + "static/media/whitecap.ac123cd3.png";